// this is an automatically generated file from the ßoilerplate framework for app

// /srv/codepad-project/@vue-modules/app/vue;
import project from '@/app.functions.project.js';


export default { project,  };